import React from 'react';
import styles from './network.module.scss';

const NetworkIP = ({networkIp}) => {
  // console.log("partitionInfo["+part+"]");
  // networkIp 문자열을 객체 배열로 파싱
  const ifaces = (networkIp+"").trim().split('\n').map(line => {
    const [name, size] = line.split(' ');
    return { name, size };
  });
  
  return (
    <div className={styles.network_info_container}>
      <span><h2>Network IP</h2></span>
      {ifaces.map((iface, index) => (
        <div key={index} className={styles.network_info_box}>
          <div className={styles.network_info_name}>{iface.name}</div>
          <div className={styles.network_info_size}>{iface.size}</div>
        </div>
      ))}
    </div>
  );
};

export default NetworkIP;